/*** JQuery ComboBox Widget ***/

import JEditable from "jqueryEditable";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

$.widget("custom.combobox", {
    _create: function () {
        this.wrapper = $("<span>")
            .addClass("custom-combobox")
            .insertAfter(this.element);

        this.element.hide();
        this._createAutocomplete();
    },

    _createAutocomplete: function () {
        var selected = this.element.children(":selected"),
            value = selected.val() ? selected.text() : "";

        this.input = $("<input>")
            .appendTo(this.wrapper)
            .val(value)
            .attr("title", "")
            //            .addClass("custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left")
            .autocomplete({
                delay: 0,
                minLength: 0,
                source: $.proxy(this, "_source")
            })
            .tooltip({
                classes: {
                    "ui-tooltip": "ui-state-highlight"
                }
            });

        this._on(this.input, {
            autocompleteselect: function (event, ui) {
                ui.item.option.selected = true;
                this._trigger("select", event, {
                    item: ui.item.option
                });
                $.isFunction(this.options.onSelection) && this.options.onSelection(this.input, ui.item.value);
            },

            autocompletechange: "_noop" //"_removeIfInvalid"
        });
    },

    _source: function (request, response) {
        var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
        response(this.element.children("option").map(function () {
            var text = $(this).text();
            if (this.value && (!request.term || matcher.test(text)))
                return {
                    label: text,
                    value: text,
                    option: this
                };
        }));
    },

    _removeIfInvalid: function (event, ui) {

        // Selected an item, nothing to do
        if (ui.item) {
            return;
        }

        // Search for a match (case-insensitive)
        var value = this.input.val(),
            valueLowerCase = value.toLowerCase(),
            valid = false;
        this.element.children("option").each(function () {
            if ($(this).text().toLowerCase() === valueLowerCase) {
                this.selected = valid = true;
                return false;
            }
        });

        // Found a match, nothing to do
        if (valid) {
            return;
        }

        // Remove invalid value
        this.input
            .val("")
            .attr("title", value + " didn't match any item")
            .tooltip("open");
        this.element.val("");
        this._delay(function () {
            this.input.tooltip("close").attr("title", "");
        }, 2500);
        this.input.autocomplete("instance").term = "";
    },

    _destroy: function () {
        this.wrapper.remove();
        this.element.show();
    },

    _noop: function () {
    }
});

/*** JEditable ComboBox Plugin ***/
class ComboBoxEditable extends CustomTagEditable{
    element (settings, original) {
        var $selection = $('<select><option value=""></option></select>');
        for (let item of settings.autocompletionData)
            $selection.append(`<option value="${item}">${item}</option>`);
        var $this = $(this);
        $this.append($selection);
        $selection.combobox(settings);
        var $input = $this.find('input');
        if (settings.preprocess) settings.preprocess($input);

        let showAllWasOpen = false;
        $input.after($("<button>")
            .attr("tabIndex", -1)
            .attr("title", "Show All Items")
            .attr("type", "toggle")
            .addClass("custom-combobox-toggle icon-arrow-down-5")
            .on("mousedown", function () {
                showAllWasOpen = $input.autocomplete("widget").is(":visible");
            })
            .on("click", function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $input.trigger("focus");

                // Close if already visible
                if (showAllWasOpen) {
                    return;
                }

                // Pass empty string as value to search for, displaying all results
                $input.autocomplete("search", "");
            }));

        return $input;
//        return ($selection);
    }
    content (string, settings, original) {
        $('input', this).val(string);
    }
    plugin (settings, original) {
        settings.onblur = 'ignore';
        $(original).find("select").combobox(settings);
    }
}


JEditable.addInputType('combobox', ComboBoxEditable);